import { apiCall } from './api.service';

export const getWorkflows = async (token, organisationId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/workflows`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const getWorkflow = async (token, organisationId, workflowId) => {
    const method = 'get';
    const path = `api/v1/organisations/${organisationId}/workflows/${workflowId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const createWorkflow = async (token, organisationId, workflowData) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/workflows`;

    const response = await apiCall(method, workflowData, path, token);
    return response;
};

export const updateWorkflow = async (token, organisationId, workflowId, workflowData) => {
    const method = 'put';
    const path = `api/v1/organisations/${organisationId}/workflows/${workflowId}`;

    const response = await apiCall(method, workflowData, path, token);
    return response;
};

export const archiveWorkflow = async (token, organisationId, workflowId) => {
    const method = 'delete';
    const path = `api/v1/organisations/${organisationId}/workflows/${workflowId}`;

    const response = await apiCall(method, {}, path, token);
    return response;
};

export const saveDraftVersion = async (token, organisationId, workflowId, definition) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/workflows/${workflowId}/versions`;

    const response = await apiCall(method, definition, path, token);
    return response;
};

export const publishVersion = async (token, organisationId, workflowId, versionId) => {
    const method = 'post';
    const path = `api/v1/organisations/${organisationId}/workflows/${workflowId}/versions/${versionId}/publish`;

    const response = await apiCall(method, {}, path, token);
    return response;
};
